import { request as sipTrunksRequest } from '../user/voip_telephony/sip_trunks/sipTrunks.request.js';

//********************* GET CONNECTED APP PHONE NUMBERS ********************************//
// Looks up whether appId is registered as a Connected App on any of the current
// user's owned/admin'd trunks (GET /sip-trunks - owner/admin-scoped, same endpoint
// trunk-connected-apps.tab.js itself reads/writes), and if so, resolves itemId's
// value for every non-empty phone field across every matching entry (dedupe by
// field_id, since more than one trunk could register the same app). Returns []
// if nothing matches, every field is empty, or the request fails.
export async function getConnectedAppPhoneNumbers(appId, itemId) {
    let trunks;
    try {
        trunks = await sipTrunksRequest('/sip-trunks');
    } catch(err) {
        console.error('Failed to load sip trunks for connected-app lookup', err);
        return [];
    }

    const seenFieldIds = new Set();
    const numbers = [];

    for (const trunk of trunks) {
        for (const entry of trunk.connected_apps || []) {
            if (String(entry.app_id) !== String(appId)) continue;

            for (const fieldId of String(entry.phone_field_ids || '').split(',').filter(Boolean)) {
                if (seenFieldIds.has(fieldId)) continue;
                seenFieldIds.add(fieldId);

                const rawValue = await gudhub.getFieldValue(appId, itemId, fieldId);
                if (!rawValue) continue;

                const field = await gudhub.getField(appId, fieldId);
                const fieldName = field?.field_name || 'Phone';

                // A "multiple" phone field (gh_elements/phone/phone.js) stores
                // every number it holds joined into one comma-separated string
                // (list.filter(Boolean).join()) - split it back out so each
                // number becomes its own switchable pill, instead of one pill
                // whose value is an undialable "num1,num2" blob.
                const values = String(rawValue).split(',').map((v) => v.trim()).filter(Boolean);

                values.forEach((value, index) => {
                    numbers.push({
                        fieldId,
                        fieldName: values.length > 1 ? `${fieldName} ${index + 1}` : fieldName,
                        value
                    });
                });
            }
        }
    }

    return numbers;
}
